import { memo } from 'react';

import { usePrivateWorkspaceAgentGuidedVariantMediaSelection } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/usePrivateWorkspaceAgentGuidedVariantMediaSelection';
import { usePrivateWorkspaceAgentSmartResizeSavedCatalog } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/usePrivateWorkspaceAgentSmartResizeSavedCatalog';
import { WorkspaceAgentGuidedVariantScaleOrCropSettings } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantScaleOrCropSettings';
import { type WorkspaceAgentGuidedVariantGenerateRequest } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/workspaceAgentGuidedVariantGenerateRequest';

export type PrivateWorkspaceAgentGuidedVariantScaleOrCropSettingsProps = {
  onGenerate: (request: WorkspaceAgentGuidedVariantGenerateRequest) => void;
};

export const PrivateWorkspaceAgentGuidedVariantScaleOrCropSettings = memo(
  ({ onGenerate }: PrivateWorkspaceAgentGuidedVariantScaleOrCropSettingsProps) => {
    const mediaSelection = usePrivateWorkspaceAgentGuidedVariantMediaSelection();
    const savedCatalog = usePrivateWorkspaceAgentSmartResizeSavedCatalog();

    return (
      <WorkspaceAgentGuidedVariantScaleOrCropSettings
        imageCount={mediaSelection.mediaCount}
        onGenerate={onGenerate}
        savedCatalog={savedCatalog}
        skippedFileCount={mediaSelection.skippedFileCount}
      />
    );
  },
);

PrivateWorkspaceAgentGuidedVariantScaleOrCropSettings.displayName =
  'PrivateWorkspaceAgentGuidedVariantScaleOrCropSettings';
